import IndexStore from 'src/stores/index';
import type {
  RequestOptions,
  ApiOptions,
  ApiPostOptions,
} from 'src/utils/redux-api';
import type {RawQuery} from 'src/types/router';

import {baseRequest} from 'src/utils/redux-api-v2';


export function get(
  store: IndexStore,
  path: string,
  query?: RawQuery,
  options?: ApiOptions,
): Promise<any> {
  return makeRequest(store, path, {
    query,
    options,
  });
}

type ProgressEvent = {
  percent?: number;
};

// TODO (kyle): the put and post methods could maybe be DRY-er?
export function post(
  store: IndexStore,
  path: string,
  data?: unknown,
  query?: RawQuery,
  options?: ApiPostOptions,
): Promise<any> {
  return makeRequest(store, path, {
    method: 'POST',
    data,
    query,
    options,
  });
}

export function put(
  store: IndexStore,
  path: string,
  data?: unknown,
  query?: RawQuery,
  options?: ApiOptions,
): Promise<any> {
  return makeRequest(store, path, {
    method: 'PUT',
    data,
    query,
    options,
  });
}

export function del(
  store: IndexStore,
  path: string,
  options?: ApiOptions,
): Promise<any> {
  return makeRequest(store, path, {
    method: 'DELETE',
    options,
  });
}

export async function makeRequest<R>(
  store: IndexStore,
  path: string,
  options: RequestOptions,
): Promise<R> {
  try {
    // @ts-expect-error - TS2339 - Property 'reduxStore' does not exist on type 'IndexStore'.
    return await store.reduxStore.dispatch(baseRequest(path, options));
  } catch (error: any) {
    // NOTE (kyle): we convert the api error here to the legacy error format.
    // in general it is bad practice to throw an object.
    throw {
      error,
      status: error.response?.status,
      response: error.responseBody || {},
    };
  }
}
